<template>

  <!-- Join Team Block -->
  <page-block
    no-body
    v-if="user"
    class="join-team-block"
    overlay-class="q-py-none"
    :bg-color="value.bgColor"
    :text-color="value.textColor"
    :text-align="value.textAlign"
    wrapper-class="column row-sm items-sm-center justify-center">

    <titled-text-element
      :value="value"/>

    <join-team-element
      :value="element"
      :key="element.id"
      v-for="element in value.elements"/>

  </page-block>

</template>

<script>

  import {mapState} from 'vuex';
  import PageBlock from '@src/components/page/page-block';
  import JoinTeamElement from '@src/components/element/join-team-element';
  import TitledTextElement from '@src/components/element/titled-text-element';

  export default {
    name: 'join-team-block',
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      JoinTeamElement,
      TitledTextElement,
    },
    computed: {
      ...mapState('session', {
        user: 'user',
      }),
    },
  };

</script>

<style lang="scss">

  .join-team-block {
    color: inherit;
  }

</style>
